type AnimationFrameRef = {
  current: number | null
}

function cancelScheduledFrame(frameRef: AnimationFrameRef) {
  if (frameRef.current != null) {
    cancelAnimationFrame(frameRef.current)
    frameRef.current = null
  }
}

// Use this for layout work that should not block the paint for the current
// user action. Use this only for visual follow-up work that can wait one frame.
// It lets the current paint happen first, then runs the callback in the next
// frame. Calling it again cancels the previous pending callback.
export function scheduleAfterNextPaint(frameRef: AnimationFrameRef, callback: () => void): () => void {
  cancelScheduledFrame(frameRef)

  frameRef.current = requestAnimationFrame(() => {
    frameRef.current = requestAnimationFrame(() => {
      frameRef.current = null
      callback()
    })
  })

  return () => cancelScheduledFrame(frameRef)
}
